module.exports = __webpack_public_path__ + "static/img/1_1_1_1.39c25a1d.jpg";